import { TEMA_ROUTE_IDS } from "./temaRouteConstants";
import { TEMA_PAGE_LOADERS } from "./pageLoaders";
import { resolveTemaRoute } from "./resolveTemaRoute";
import { loadWithChunkRetry } from "../utils/loadWithChunkRetry";

const prefetchedRouteIds = new Set();

export function clearTemaRoutePrefetchCache() {
  prefetchedRouteIds.clear();
}

export function prefetchTemaRoute(hashOrPath) {
  const route = resolveTemaRoute(hashOrPath);

  if (!route.lazy || route.id === TEMA_ROUTE_IDS.NOT_FOUND) {
    return Promise.resolve();
  }

  const loader = TEMA_PAGE_LOADERS[route.id];
  if (!loader || prefetchedRouteIds.has(route.id)) {
    return Promise.resolve();
  }

  prefetchedRouteIds.add(route.id);

  return loadWithChunkRetry(() => loader.load()).catch(() => {
    prefetchedRouteIds.delete(route.id);
  });
}
